import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { collection, getDocs } from 'firebase/firestore';
import { db } from '../../firebase';
import CreditIcon from '../CreditIcon';

function TopWrestlersSection() {
    const [topWrestlers, setTopWrestlers] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchTopWrestlers = async () => {
            try {
                setLoading(true);
                const wrestlersSnap = await getDocs(collection(db, 'wrestlers'));

                const wrestlersData = [];
                wrestlersSnap.forEach(doc => {
                    const data = doc.data();
                    if (data.isGuest) return;
                    const prices = data.prices || [];
                    const currentPrice = prices.length > 0 ? prices[prices.length - 1].value : data.price || 0;

                    wrestlersData.push({
                        id: doc.id,
                        name: data.name || data.nome || 'Unknown',
                        score: data.score || 0,
                        price: currentPrice,
                        imageUrl: data.imageUrl || '',
                        brand: data.brand || data.brandWrestler || 'Indie',
                        championTypes: data.championTypes || [],
                        gender: data.gender || 'unknown'
                    });
                });

                // Ordina per punteggio e prendi top 5
                const sorted = wrestlersData
                    .sort((a, b) => b.score - a.score)
                    .slice(0, 5);

                setTopWrestlers(sorted);
            } catch (error) {
                console.error('Errore nel caricamento dei wrestler:', error);
            } finally {
                setLoading(false);
            }
        };

        fetchTopWrestlers();
    }, []);

    if (loading) {
        return (
            <div className="row g-4 mb-4">
                <div className="col-12">
                    <div className="card border-0 shadow-sm bg-gradient-dark rounded-3">
                        <div className="card-body text-center py-5">
                            <div className="spinner-border text-warning" role="status">
                                <span className="visually-hidden">Caricamento...</span>
                            </div>
                            <p className="text-light mt-3">Caricamento top wrestler...</p>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="top-wrestlers-section mb-4">
            <div className="card border-0 shadow-lg rounded-3 overflow-hidden"
                style={{
                    background: 'linear-gradient(135deg, #1a1a1a 0%, #2a2a2a 100%)',
                    border: '1px solid rgba(255, 193, 7, 0.15)'
                }}>

                {/* Header compatto */}
                <div className="card-header border-0 py-3"
                    style={{
                        background: 'linear-gradient(90deg, rgba(255,193,7,0.1), transparent)'
                    }}>
                    <div className="d-flex align-items-center">
                        <div className="me-2">
                            <div className="bg-warning rounded-circle p-2">
                                <i className="bi bi-trophy-fill text-dark fs-5"></i>
                            </div>
                        </div>
                        <div className="flex-grow-1">
                            <h4 className="mb-0 text-light fw-bold fs-5">
                                Top 5 Wrestler
                            </h4>
                        </div>
                        <div>
                            <Link to="/wrestlers" className="btn btn-sm btn-outline-warning">
                                Tutti <i className="bi bi-chevron-right"></i>
                            </Link>
                        </div>
                    </div>
                </div>

                <div className="card-body p-3 p-md-4">
                    {/* Layout orizzontale su mobile, griglia su desktop */}
                    <div className="d-flex flex-nowrap overflow-auto pb-3 d-md-none">
                        {topWrestlers.map((wrestler, index) => (
                            <div key={wrestler.id} className="flex-shrink-0 me-3" style={{ width: '180px' }}>
                                <Link
                                    to={`/wrestlers/${wrestler.id}`}
                                    className="text-decoration-none"
                                >
                                    <div className="card h-100 border-0 shadow-sm"
                                        style={{
                                            background: 'rgba(30, 30, 30, 0.7)',
                                            border: '1px solid rgba(255, 193, 7, 0.1)',
                                            transition: 'all 0.3s ease',
                                            minHeight: '220px'
                                        }}>

                                        {/* Posizione */}
                                        <div className="position-absolute top-0 start-0 mt-2 ms-2">
                                            <div className={`rank-badge ${index === 0 ? 'rank-1' : index === 1 ? 'rank-2' : index === 2 ? 'rank-3' : 'rank-other'}`}>
                                                <span className="fw-bold">
                                                    {index === 0 && <i className="bi bi-trophy-fill"></i>}
                                                    {index === 1 && <i className="bi bi-award-fill"></i>}
                                                    {index === 2 && <i className="bi bi-award"></i>}
                                                    {index > 2 && `${index + 1}°`}
                                                </span>
                                            </div>
                                        </div>

                                        {/* Avatar e Nome */}
                                        <div className="text-center pt-4 px-2">
                                            <div className="avatar-container mx-auto mb-2">
                                                {wrestler.imageUrl ? (
                                                    <img
                                                        src={wrestler.imageUrl}
                                                        alt={wrestler.name}
                                                        className="rounded-circle object-fit-cover border border-warning border-2"
                                                        style={{
                                                            width: '70px',
                                                            height: '70px',
                                                            objectFit: 'cover'
                                                        }}
                                                    />
                                                ) : (
                                                    <div className="rounded-circle bg-dark d-flex align-items-center justify-content-center mx-auto border border-warning border-2"
                                                        style={{
                                                            width: '70px',
                                                            height: '70px'
                                                        }}>
                                                        <i className="bi bi-person-fill text-warning fs-4"></i>
                                                    </div>
                                                )}
                                            </div>

                                            {/* Nome più grande e centrato */}
                                            <h5 className="text-light mb-1 text-center fw-bold" style={{ fontSize: '1rem' }}>
                                                {wrestler.name}
                                            </h5>

                                            {/* Brand */}
                                            <div className="mb-2">
                                                <span className={`rounded-3 text-light badge ${wrestler.brand === 'Raw'
                                                    ? 'bg-raw'
                                                    : wrestler.brand === 'SmackDown'
                                                        ? 'bg-sd'
                                                        : wrestler.brand === 'NXT'
                                                            ? 'bg-nxt'
                                                            : 'bg-light text-dark'
                                                    }`}>
                                                    {wrestler.brand}
                                                </span>
                                            </div>
                                        </div>

                                        {/* Stats con icone */}
                                        <div className="card-footer border-0 bg-dark bg-opacity-10 pt-2 pb-2 px-3">
                                            <div className="d-flex justify-content-between align-items-center">
                                                <div className="d-flex align-items-center me-4">
                                                    <CreditIcon className="me-1 text-success" size={16} />
                                                    <span className="text-success fw-bold">{wrestler.price}</span>
                                                </div>
                                                <div className="d-flex align-items-center ms-5">
                                                    <i className="bi bi-trophy text-warning me-1 small"></i>
                                                    <span className="text-warning fw-bold">{wrestler.score}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </Link>
                            </div>
                        ))}
                    </div>

                    {/* Layout desktop (griglia 5 colonne) */}
                    <div className="row row-cols-2 row-cols-md-3 row-cols-lg-5 g-3 d-none d-md-flex">
                        {topWrestlers.map((wrestler, index) => (
                            <div key={wrestler.id} className="col">
                                <div className="h-100">
                                    <Link
                                        to={`/wrestlers/${wrestler.id}`}
                                        className="text-decoration-none"
                                    >
                                        <div className="card h-100 border-0 shadow-sm hover-lift"
                                            style={{
                                                background: 'rgba(30, 30, 30, 0.7)',
                                                border: '1px solid rgba(255, 193, 7, 0.1)',
                                                transition: 'all 0.3s ease'
                                            }}>

                                            {/* Posizione */}
                                            <div className="position-absolute top-0 start-0 mt-2 ms-2">
                                                <div className={`rank-badge ${index === 0 ? 'rank-1' : index === 1 ? 'rank-2' : index === 2 ? 'rank-3' : 'rank-other'}`}>
                                                    <span className="fw-bold">
                                                        {index === 0 && <i className="bi bi-trophy-fill"></i>}
                                                        {index === 1 && <i className="bi bi-award-fill"></i>}
                                                        {index === 2 && <i className="bi bi-award"></i>}
                                                        {index > 2 && `#${index + 1}`}
                                                    </span>
                                                </div>
                                            </div>

                                            {/* Avatar e Nome (centrato e grande) */}
                                            <div className="text-center pt-4 px-3">
                                                <div className="avatar-container mx-auto mb-3">
                                                    {wrestler.imageUrl ? (
                                                        <img
                                                            src={wrestler.imageUrl}
                                                            alt={wrestler.name}
                                                            className="rounded-circle object-fit-cover border border-warning border-2"
                                                            style={{
                                                                width: '90px',
                                                                height: '90px',
                                                                objectFit: 'cover'
                                                            }}
                                                        />
                                                    ) : (
                                                        <div className="rounded-circle bg-dark d-flex align-items-center justify-content-center mx-auto border border-warning border-2"
                                                            style={{
                                                                width: '90px',
                                                                height: '90px'
                                                            }}>
                                                            <i className="bi bi-person-fill text-warning fs-2"></i>
                                                        </div>
                                                    )}
                                                </div>

                                                {/* Nome grande e centrato */}
                                                <h5 className="text-light mb-2 text-center fw-bold" style={{ fontSize: '1.1rem' }}>
                                                    {wrestler.name}
                                                </h5>

                                                {/* Brand */}
                                                <div className="mb-3">
                                                    <span className={`rounded-3 text-light badge ${wrestler.brand === 'Raw'
                                                        ? 'bg-raw'
                                                        : wrestler.brand === 'SmackDown'
                                                            ? 'bg-sd'
                                                            : wrestler.brand === 'NXT'
                                                                ? 'bg-nxt'
                                                                : 'bg-light text-dark'
                                                        }`}>
                                                        {wrestler.brand}
                                                    </span>
                                                </div>
                                            </div>

                                            {/* Stats con icone */}
                                            <div className="card-footer border-0 bg-dark bg-opacity-10 pt-2 pb-2 px-3">
                                                <div className="d-flex justify-content-between align-items-center">
                                                    <div className="d-flex align-items-center me-5">
                                                        <CreditIcon className="me-1 text-success" size={16} />
                                                        <span className="text-success fw-bold">{wrestler.price}</span>
                                                    </div>
                                                    <div className="d-flex align-items-center ms-5">
                                                        <i className="bi bi-trophy text-warning me-1 small"></i>
                                                        <span className="text-warning fw-bold">{wrestler.score}</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </Link>
                                </div>
                            </div>
                        ))}
                    </div>

                    {/* Footer compatto */}
                    <div className="mt-4 pt-3 border-top border-warning border-opacity-25">
                        <div className="d-flex flex-column flex-md-row justify-content-between align-items-center">
                            <div className="text-center text-md-start mb-2 mb-md-0">
                                <p className="text-light opacity-75 small mb-0">
                                    <i className="bi bi-info-circle me-1"></i>
                                    Classifica basata sui punteggi attuali
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Stili inline specifici per questo componente */}
            <style>{`
        .top-wrestlers-section .hover-lift:hover {
          transform: translateY(-5px);
          box-shadow: 0 10px 20px rgba(0, 0, 0, 0.3) !important;
          border-color: rgba(255, 193, 7, 0.3) !important;
        }
        
        .top-wrestlers-section .rank-badge {
          width: 35px;
          height: 35px;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          font-weight: bold;
          font-size: 0.9rem;
        }
        
        .top-wrestlers-section .rank-1 {
          background: linear-gradient(135deg, #FFD700, #FFA500);
          color: #000;
          box-shadow: 0 0 10px rgba(255, 215, 0, 0.5);
        }
        
        .top-wrestlers-section .rank-2 {
          background: linear-gradient(135deg, #C0C0C0, #A0A0A0);
          color: #000;
          box-shadow: 0 0 8px rgba(192, 192, 192, 0.5);
        }
        
        .top-wrestlers-section .rank-3 {
          background: linear-gradient(135deg, #CD7F32, #A0522D);
          color: #000;
          box-shadow: 0 0 8px rgba(205, 127, 50, 0.5);
        }
        
        .top-wrestlers-section .rank-other {
          background: rgba(255, 255, 255, 0.1);
          color: #fff;
        }
        
        /* Scrollbar personalizzata per mobile */
        .top-wrestlers-section .overflow-auto::-webkit-scrollbar {
          height: 6px;
        }
        
        .top-wrestlers-section .overflow-auto::-webkit-scrollbar-track {
          background: rgba(255, 255, 255, 0.1);
          border-radius: 10px;
        }
        
        .top-wrestlers-section .overflow-auto::-webkit-scrollbar-thumb {
          background: rgba(255, 193, 7, 0.5);
          border-radius: 10px;
        }
        
        /* Colori brand personalizzati */
        .bg-raw {
          background-color: #CC0000 !important;
        }
        
        .bg-sd {
          background-color: #00509E !important;
        }
        
        .bg-nxt {
          background-color: #663399 !important;
        }
        
        /* Mobile specific */
        @media (max-width: 767.98px) {
          .top-wrestlers-section .card {
            min-width: 180px;
          }
          
          .top-wrestlers-section .avatar-container img,
          .top-wrestlers-section .avatar-container div {
            width: 70px !important;
            height: 70px !important;
          }
        }
        
        /* Tablet */
        @media (min-width: 768px) and (max-width: 991.98px) {
          .top-wrestlers-section .avatar-container img,
          .top-wrestlers-section .avatar-container div {
            width: 80px !important;
            height: 80px !important;
          }
        }
      `}</style>
        </div>
    );
}

export default TopWrestlersSection;